import { CreateBillingAccount } from "@/components/forms/CreateBillingAccount.tsx";
import { NoticeBlock } from "@/components/NoticeBlock.tsx";
import type { EBillingState } from "@/modules/billing/billingLogic.tsx";
import { Trans } from "@lingui/react/macro";

export function AccountIsBeingValidatedText() {
    return (
        <>
            <Trans>Account details are being validated.</Trans>{" "}
            <Trans>
                You will be able to set up payment methods and use cloud services once the validation is complete.
            </Trans>
        </>
    );
}

export function NoValidBillingAccountNotice({ state }: { state: EBillingState }) {
    const { defaultAccount } = state;
    const isPending = defaultAccount?.status === "PENDING_VALIDATION";
    return (
        <NoticeBlock color="primary" icon="jp-warning-icon" button={isPending ? null : <CreateBillingAccount />}>
            {isPending ? (
                <AccountIsBeingValidatedText />
            ) : (
                <Trans>An active billing account is needed to create resources.</Trans>
            )}
        </NoticeBlock>
    );
}
